<template>
    <div class="container pt-4 mb-5 lower-width" v-if="status=='success'">
        <div class="card shadow-sm ps-border" v-if="paymentData.user_full_name">
            <div class="card-header">
                <kt-row>
                    <kt-col lg="3" md="3" xs="12" class="text-center">
                        <img v-if="paymentData.profile_image"
                             width="100"
                             height="100"
                             :src="paymentData.profile_image"
                             alt="profile"
                        >
                        <img v-else
                             width="100"
                             height="100"
                             src="https://img.icons8.com/bubbles/100/000000/user.png"
                             :alt="paymentData.user_full_name"
                        >
                    </kt-col>
                    <kt-col lg="6" md="6" xs="12" id="info_col">
                        <p class="pay-to">{{ $t('pardakht_shakhsi.p.pay_to') }}</p>
                        <h3 class="user_name">{{ paymentData.user_full_name }}</h3>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <div class="paystar-logo">
                            <img
                                :src=" paymentData.site_logo"
                                :alt="paymentData.site_name"
                                style="max-width: 100px; max-height:100px"
                            >
                        </div>
                    </kt-col>
                </kt-row>
            </div>
            <div class="card-body">
                <form @submit.prevent="submit" id="payment_form">
                    <kt-form-section>
                        <kt-row>
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label>
                                        {{ $t('money_request.payer_name') }}
                                    </kt-form-label>
                                    <div class="form-input form-control">
                                        {{ paymentData.payer_name }}
                                    </div>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                        <kt-row>
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label>
                                        {{ $t('money_request.pay_description') }}
                                    </kt-form-label>
                                    <p class="description mt-2 pl-2">
                                        {{ paymentData.description }}
                                    </p>
                                </kt-form-group>
                            </kt-col>

                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label>
                                        {{ $t('money_request.pay_amount') }}
                                    </kt-form-label>
                                    <currency-input
                                        dir="rtl"
                                        :currency="{
                                                suffix: ' ' + $t('currency.rial') + ' ',
                                                prefix: ''
                                            }"
                                        v-model="paymentData.payment_amount"
                                        :precision="0"
                                        :value-as-integer="true"
                                        disabled
                                        id="amount"
                                        name="amount"
                                        class="form-input form-control"
                                        style="text-align: center; color: #646c9a"
                                    >
                                    </currency-input>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label>
                                        {{ $t('money_request.payer_wage') }}
                                    </kt-form-label>
                                    <div class="form-input form-control">
                                        {{ paymentData.payer_wage }}
                                    </div>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="12" md="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label>
                                        {{ $t('money_request.transaction_code') }}
                                    </kt-form-label>
                                    <div class="form-input form-control">
                                        {{ paymentData.tracking_number }}
                                    </div>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                    </kt-form-section>
                    <kt-form-action class="mt-2 mb-2 text-center">
                        <kt-button
                            class="m-2 form-submit p-3 pr-5 pl-5"
                            size="md"
                            variant="success"
                            type="submit"
                            v-bind:wide="true"
                            id="submit_btn"
                        >
                            {{ $t('money_request.pay_btn') }}
                            <i class="fa fa-credit-card ml-3"></i>
                        </kt-button>
                    </kt-form-action>
                </form>
            </div>
        </div>
        <kt-panel v-else>
            <kt-panel-body>
                <p class="font-weight-bolder text-center" :style="{fontSize: '15px'}">
                    {{ $t('message.payment_page_not_found') }}
                </p>
            </kt-panel-body>
        </kt-panel>
    </div>
    <loader v-else></loader>
</template>

<script>

import {mapGetters} from "vuex";
import Loading from '@/components/custom/loading'
import { BASE_PATH } from '@/common/config'

export default {

    components: {
        'loader': Loading
    },
    computed: {
        ...mapGetters('moneyRequest', [
            'status',
            'paymentData'
        ])
    },
    data() {
        return {
            'tracking_code': this.$route.params.tracking_code
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('moneyRequest/find', vm.tracking_code)
        })
    },
    methods: {
        submit() {
            window.location = BASE_PATH + '/money-request/pay/' + this.tracking_code;
        }
    }
}
</script>

<style scoped>
.ps-border {
    border: 1px solid transparent;
    -o-border-image: linear-gradient(
        135deg,rgba(0,190,165,1) 0%,
        rgba(255,255,255,1) 24%,
        rgba(0,190,165,1) 40%,
        rgba(255,255,255,1) 60%,
        rgba(0,190,165,1) 79%,
        rgba(255,255,255,1) 92%);
    border-image: linear-gradient(
        135deg,rgba(0,190,165,1) 0%,
        rgba(255,255,255,1) 24%,
        rgba(0,190,165,1) 40%,
        rgba(255,255,255,1) 60%,
        rgba(0,190,165,1) 79%,
        rgba(255,255,255,1) 92%);
    border-image-slice: 2;
}
.lower-width {
    max-width: 650px;
}
.user-img img {
    width: 100px;
}
#info_col{
    text-align: center;
}
.pay-to, .phone_number {
    font-size: 1.3rem;
}
.user_name {
    color: #646c9a;
}
.phone {
    color: #ee3525;
}
.paystar-logo {
    margin: auto;
    text-align: center;
}
.paystar-logo img {
    width: 100%;
}
#amount {
    font-size: 3rem;
    color: #00bea5;
    text-align: center;
}
.form-spn {
    font-size: 1rem;
    padding-left: 10px;
}
.form-input {
    font-size: 1.4rem;
    padding-left: 4.1rem!important;
}
.form-submit {

}


@media screen and (max-width: 440px){
    .user-img img {
        width: 100%;
    }
}
@media screen and (max-width: 767px){
    .paystar-logo {
        padding-top: 10px;
        border-top: #00bea5 2px dashed;
    }
    .paystar-logo img {
        width: 150px;
    }
}
</style>